import type { Record } from "@suse-o11y/record";
import { type Observable, filter } from "@suse-o11y/rxjs";

export interface TypedAction<N extends string> {
	type: N;
}

export type TypedReducer<S, A extends TypedAction<any>> = (state: S, action: A) => S;

export function pairActionTypeToReducer<ActionType extends string, A extends TypedAction<ActionType>, S>(
	type: ActionType,
	reducer: TypedReducer<S, A>,
): Record<string, TypedReducer<S, A>> {
	return { [type as string]: reducer };
}

export const ofType =
	<T extends TypedAction<N>, N extends string>(...typeNames: Array<N>) =>
	(source: Observable<T>) =>
		source.pipe(filter<T>((action) => typeNames.includes(action.type)));

export const typedStream =
	<T extends TypedAction<any>>(t: T["type"]) =>
	(source: Observable<T>) =>
		source.pipe(filter<T>((action) => action.type === t));
